import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ApiAuthenticationProviderEnum,
  ApiAuthenticationProviderTypes,
  AuthenticationProvider,
  GoogleSignInComponent,
  MicrosoftSignInComponent,
  PasswordSignInComponent,
} from '@aodocs/authentication';

@Component({
  selector: 'aodocs-select-sign-in-provider',
  standalone: true,
  imports: [CommonModule, GoogleSignInComponent, MicrosoftSignInComponent, PasswordSignInComponent],
  templateUrl: './select-sign-in-provider.component.html',
  styleUrls: ['./select-sign-in-provider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectSignInProviderComponent implements OnInit {
  @Input() providers: ApiAuthenticationProviderTypes[] = [];

  @Output() authenticateWith = new EventEmitter<AuthenticationProvider>();

  displayGoogle = false;
  displayMicrosoft = false;
  displayPassword = false;

  ngOnInit(): void {
    if (this.providers.length) {
      this.displayGoogle = this.providers.includes(ApiAuthenticationProviderEnum.GOOGLE);
      this.displayMicrosoft = this.providers.includes(ApiAuthenticationProviderEnum.MICROSOFT);
      this.displayPassword = this.providers.includes(ApiAuthenticationProviderEnum.PASSWORD);
    } else {
      this.displayGoogle = true;
      this.displayMicrosoft = true;
      this.displayPassword = true;
    }
  }

  startGoogleLogin(): void {
    this.authenticateWith.emit(AuthenticationProvider.GOOGLE);
  }
  startMicrosoftLogin(): void {
    this.authenticateWith.emit(AuthenticationProvider.MICROSOFT);
  }
  startPasswordLogin(): void {
    this.authenticateWith.emit(AuthenticationProvider.PASSWORD);
  }
}
